import { render, staticRenderFns } from "./Bech32.vue?vue&type=template&id=dfeab55a&scoped=true&"
import script from "./Bech32.vue?vue&type=script&lang=js&"
export * from "./Bech32.vue?vue&type=script&lang=js&"
import style0 from "./Bech32.vue?vue&type=style&index=0&id=dfeab55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeab55a",
  null
  
)

export default component.exports